(() => {
  const WRAPPER_SELECTOR = '.grid__item.product__media-wrapper';
  const isMobilePortrait = () => window.innerWidth <= 767 && window.innerHeight / window.innerWidth > 1.5;

  const init = () => {
    if (!isMobilePortrait()) return;
    const wrapper = document.querySelector(WRAPPER_SELECTOR);
    const form = document.querySelector('#tee-artwork-form');
    if (!wrapper || !form || wrapper.dataset.mgStickyReady === 'true') return;
    wrapper.dataset.mgStickyReady = 'true';

    let galleryContent;
    let toggle;
    let framePending = false;
    let sticky = false;

    const setSticky = (nextSticky) => {
      if (sticky === nextSticky) return;
      sticky = nextSticky;
      document.body.classList.toggle('gallery--sticky', sticky);
      document.documentElement.classList.toggle('gallery--sticky', sticky);
      if (sticky) return;
      document.body.classList.remove('gallery--sticky-collapsed');
      document.documentElement.classList.remove('gallery--sticky-collapsed');
      wrapper.style.removeProperty('height');
      if (!toggle) return;
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Vorschau nach oben einklappen');
    };

    const update = () => {
      framePending = false;
      if (!galleryContent || !isMobilePortrait()) {
        setSticky(false);
        return;
      }
      const wrapperRect = wrapper.getBoundingClientRect();
      const formRect = form.getBoundingClientRect();
      const galleryHeight = galleryContent.getBoundingClientRect().height;
      const nextSticky = wrapperRect.top < -10 && formRect.bottom > galleryHeight;
      setSticky(nextSticky);
      if (nextSticky) wrapper.style.height = `${Math.ceil(galleryHeight) + 10}px`;
    };

    const scheduleUpdate = () => {
      if (framePending) return;
      framePending = true;
      window.requestAnimationFrame(update);
    };

    const attach = () => {
      const gallery = wrapper.querySelector('#tee-gallery');
      galleryContent = wrapper.querySelector('.tee-gallery-content');
      if (!gallery || !galleryContent) return false;
      toggle = gallery.querySelector('.gallery-toggle-button');
      if (!toggle) {
        toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'gallery-toggle-button';
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', 'Vorschau nach oben einklappen');
        toggle.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 15.5 12 8.5 19 15.5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        toggle.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const collapsed = document.body.classList.toggle('gallery--sticky-collapsed');
          document.documentElement.classList.toggle('gallery--sticky-collapsed', collapsed);
          toggle.setAttribute('aria-expanded', String(!collapsed));
          toggle.setAttribute('aria-label', collapsed ? 'Vorschau nach unten ausklappen' : 'Vorschau nach oben einklappen');
        });
        gallery.appendChild(toggle);
      }
      window.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate, { passive: true });
      new ResizeObserver(scheduleUpdate).observe(galleryContent);
      scheduleUpdate();
      return true;
    };

    if (attach()) return;
    const observer = new MutationObserver(() => {
      if (!attach()) return;
      observer.disconnect();
    });
    observer.observe(wrapper, { childList: true, subtree: true });
  };

  const start = () => {
    init();
    if (document.querySelector('#tee-artwork-form')) return;
    const formObserver = new MutationObserver(() => {
      if (!document.querySelector('#tee-artwork-form')) return;
      formObserver.disconnect();
      init();
    });
    formObserver.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
